import { useMemo } from "react";
import HeaderBar from "../../../components/Header/HeaderBar";
import { localStorageSizes } from "../../../utils/debug";
import { useSelector } from "react-redux";
import axios from "../../../services/axios/backendAxios";
import flash from "../../../services/flash";
import { cleanUpUndoHistory } from "../../../components/SiteMap/utils/history";
const DebugPage = () => {
  const store_state = useSelector((s) => s);
  const sizes = useMemo(() => {
    return localStorageSizes();
  }, []);
  return (
    <div className="flex flex-col ">
      <HeaderBar
        title="Debug Page"
        buttons={[
          {
            color: "green",
            // disabled: !isDirty,
            label: "Send To Developers",
            onClick: async () => {
              await axios.post("/utilities/debug/redux", {
                usage: sizes,
                redux: store_state,
                src: "web",
              });
              flash.success("Sent!");
            },
          },
          {
            color: "green",
            // disabled: !isDirty,
            label: "Clean Up Storage",
            onClick: async () => {
              cleanUpUndoHistory();
              flash.success("Storage cleaned");
            },
          },
        ]}
      />
      <div className="w-full px-1 lg:px-10">
        <h2 className="text-lg font-bold my-2">Local Storage Usage</h2>
        <table className="w-full">
          <thead>
            <tr>
              <th>Key</th>
              <th>Size (kilobytes)</th>
            </tr>
          </thead>
          <tbody>
            {Object.keys(sizes).map((key) => (
              <tr key={key}>
                <td>{key}</td>
                <td>{Math.round((sizes[key] / 1024) * 100) / 100}</td>
              </tr>
            ))}
          </tbody>
        </table>
        <h2 className="text-lg font-bold my-2">Redux State</h2>
        <textarea
          value={JSON.stringify(store_state)}
          className="p-2 border w-full"
          readOnly
        />
      </div>
    </div>
  );
};
export default DebugPage;
